import script from "./StopPanelRoutes.vue?vue&type=script&setup=true&lang=js"
export * from "./StopPanelRoutes.vue?vue&type=script&setup=true&lang=js"

import "./StopPanelRoutes.vue?vue&type=style&index=0&id=1af8b596&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1af8b596"]])

export default __exports__